import React, { useCallback, useEffect } from 'react';
import { styled } from 'baseui';
import { useSetAtom } from 'jotai';
import { RESET } from 'jotai/utils';
import type { SendEventT } from '../../../analytics/types';
import type { FocusSuggestionOptionsT, PanelStateT, SUGGESTION_CATEGORY } from '../../../common/review-suggestions-side-panel';
import ReviewSuggestionsSidePanelContent from '../../../common/review-suggestions-side-panel/review-suggestions-side-panel-content';
import { ReviewSuggestionsSidePanelHeader } from '../../../common/review-suggestions-side-panel/review-suggestions-side-panel-header';
import { focusedSuggestionAtom } from './atoms/focused-suggestion-atom';
import useSuggestionsHandlers from './hooks/use-suggestions-handlers';
import type { TrackingValidationResultT } from './types';
type PropsT = {
  trackingDetails: TrackingValidationResultT[] | null;
  onEvaluate: () => Promise<void>;
  showNotification?: (notificationType: string, message: string) => void;
  sendEvent: SendEventT;
  suggestionsError: Error | null;
  setTrackingDetails: React.Dispatch<React.SetStateAction<TrackingValidationResultT[] | null>>;
  panelState?: PanelStateT;
  onCloseSidePanel: () => void;
  title?: string;
};
const Container = styled<'div', {}>('div', ({
  $theme
}) => ({
  ...$theme.borders.border200,
  display: 'flex',
  flexDirection: 'column',
  borderTop: 'none',
  borderBottom: 'none',
  width: '100%',
  overflow: 'hidden'
  // marginTop: $theme.sizing.scale800,
}));
const ReviewSuggestionsSidePanel = ({
  trackingDetails,
  onEvaluate,
  showNotification,
  sendEvent,
  setTrackingDetails,
  panelState,
  onCloseSidePanel,
  title = 'Review Suggestions'
}: PropsT) => {
  const {
    suggestionsData,
    suggestionActionHandler
  } = useSuggestionsHandlers({
    trackingDetails,
    setTrackingDetails
  });
  const setFocusedSuggestion = useSetAtom(focusedSuggestionAtom);

  // reset the focused suggestion when the component unmounts
  useEffect(() => {
    return () => {
      setFocusedSuggestion(RESET);
    };
  }, [setFocusedSuggestion]);
  const handleFocusSuggestion = useCallback((id: string, options: FocusSuggestionOptionsT, category: SUGGESTION_CATEGORY) => {
    setFocusedSuggestion({
      id,
      category,
      meta: {
        [category]: options
      }
    });
  }, [setFocusedSuggestion]);
  return <Container>
      <ReviewSuggestionsSidePanelHeader title={title} onClose={onCloseSidePanel} />
      <ReviewSuggestionsSidePanelContent initialState={suggestionsData} onSuggestionAction={suggestionActionHandler} onEvaluate={onEvaluate} showNotification={showNotification} sendEvent={sendEvent} onFocusSuggestion={handleFocusSuggestion} panelState={panelState} />
    </Container>;
};
export default ReviewSuggestionsSidePanel;